/**
 * Google map default options
 */
var defaultMapOptions = {
    zoom: 16,
    center: new google.maps.LatLng(45.510450, -73.565676),
    backgroundColor: '#ffffff',
    scrollwheel: false,
    styles: [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#333333"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "lightness": 20
                },
                {
                    "color": "#fefefe"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                },
                {
                    "color": "#fefefe"
                }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#000000"
                }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#e2e2e2"
                }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#000000"
                }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#e2e2e2"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "lightness": 20
                },
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.attraction",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#7cb18c"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.place_of_worship",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#e2e2e2"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway.controlled_access",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#000000"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e2e2e2"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "lightness": 16
                },
                {
                    "color": "#e2e2e2"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#000000"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#c27171"
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "lightness": 19
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "lightness": 17
                },
                {
                    "visibility": "on"
                },
                {
                    "color": "#cccccc"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ]
};

$(function () {
    if (!$('#map-canvas').length) {
        return;
    }

    /**
     * Map
     */
    map = new google.maps.Map(document.getElementById('map-canvas'), defaultMapOptions);

    new google.maps.Marker({
        position: new google.maps.LatLng(45.51047742938552, -73.56580688095096),
        map: map,
        icon: {
            path: "M15.955,17.804L11,14.204l-4.955,3.6l1.893-5.825l-4.956-3.6h6.125L11,2.553l1.893,5.825h6.125l-4.955,3.601 L15.955,17.804",
            fillColor: '#fff',
            fillOpacity: 1,
            anchor: new google.maps.Point(11,11),
            strokeWeight: 0,
            scale: 1.3
        }
    });

    var building = new google.maps.Marker({
        position: new google.maps.LatLng(45.51047742938552, -73.56580688095096),
        map: map,
        icon: {
            path: "M11,0C4.925,0,0,4.925,0,11s4.925,11,11,11s11-4.925,11-11S17.075,0,11,0z M15.955,17.804L11,14.204 l-4.955,3.6l1.893-5.825l-4.956-3.6h6.125L11,2.553l1.893,5.825h6.125l-4.955,3.601L15.955,17.804z",
            fillColor: '#ef4b58',
            fillOpacity: 1,
            anchor: new google.maps.Point(11,11),
            strokeWeight: 0,
            scale: 1.3
        }
    });

    var tooltip = new Tooltip({
        marker: building,
        content: 'Laurent &amp; Clark',
        cssClass: 'tooltip-label tooltip-building'
    });

    // Markers
    var markers = [];

    $('.Map__navigation li').each(function () {
        var nav_element = $(this);

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng($(this).data('latitude'), $(this).data('longitude')),
            icon: '/images/frontend/marker.png',
            map: map
        });

        var content = $(this).find('.title').clone();

        content.children('.material-icons').remove();

        var tooltip = new Tooltip({
            marker: marker,
            content: content.html(),
            cssClass: 'tooltip-label'
        });

        google.maps.event.addListener(marker, 'click', function () {
            map.panTo(this.getPosition());
            setTimeout(function () {
                for (id in markers) {
                    markers[id].tooltip.hide();
                }
                tooltip.show();
            }, 100);

            $('.Map').addClass('Map--navigation-opened');

            $('.Map__navigation ul').getNiceScroll().doScrollPos(0, nav_element.position().top);

            nav_element.addClass('active').siblings().removeClass('active');
        });
        markers[$(this).data('id')] = {marker: marker, tooltip: tooltip};
    });

    /**
     * Navigation
     */
    $('.Map__navigation ul').niceScroll({
        cursorwidth: 10,
        cursorborderradius: 0
    });

    $('.Map__navigation .close-panel').on('click', function () {
        $('.Map').toggleClass('Map--navigation-opened');
    });

    $('.Map__navigation li').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');

        for (id in markers) {
            markers[id].tooltip.hide();
        }

        var marker = markers[$(this).data('id')];

        marker.tooltip.show();

        map.panTo(marker.marker.getPosition());
    });

    /**
     * Filters
     */
    $('.MapFilters a').on('click', function (event) {
        event.preventDefault();

        var hash = $(this).attr('href').substr(1);

        if ($(this).hasClass('active') || hash == 'all') {
            for (id in markers) {
                var marker = markers[id];
                marker.marker.setVisible(true);
            }

            $('.Map__navigation li').show();

            $('.MapFilters a').removeClass('active');

            $('.MapFilters a[href="#all"]').addClass('active');

            return;
        }

        for (id in markers) {
            var marker = markers[id];
            marker.marker.setVisible(false);
        }

        $('.MapFilters a').removeClass('active');

        $(this).addClass('active');

        $('.Map__navigation li').hide();

        $('.Map__navigation li[data-category="' + hash + '"]').each(function () {
            $(this).show();
            markers[$(this).data('id')].marker.setVisible(true);
        });

        $('.Map').addClass('Map--navigation-opened');
    });
});


// WEBPACK FOOTER //
// ./public/js/map.js